import React, { useEffect, useState } from 'react'

// Services
import LocalStorageService from '../../../services/LocalStorageService'
import OrganisationTagService from '../../../services/OrganisationTagService'
import UserService from '../../../services/UserService'

// Appt Components
import DateInput from '../../../components/simple/input/DateInput'
import MaskedInput from '../../../components/simple/input/MaskedInput'
import Select from '../../../components/simple/input/Select'
import TextInput from '../../../components/simple/input/TextInput'

import constants from '../../../utils/constants'

const ValueBox = (props) => {
  const [valueField, setValueField] = useState()
  const [autoCompleteValues, setAutoCompleteValues] = useState([])
  const [timeValue, setTimeValue] = useState()

  const [query, setQuery] = useState(props.query || {})
  useEffect(() => { setQuery(props.query || {}) }, [props.query])

  const [index, setIndex] = useState(props.index || 0)
  useEffect(() => { setIndex(props.index || 0) }, [props.index])

  const [type, setType] = useState(props.type || '')
  // useEffect(() => { setType(props.type || '') }, [props.type])

  const [fieldType, setFieldType] = useState(props.fieldType || '')
  // useEffect(() => { setFieldType(props.fieldType || '') }, [props.fieldType])

  const [list, setList] = useState(props.list || '')
  useEffect(() => { setList(props.list || '') }, [props.list])

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const terms = LocalStorageService.get('terms')



  useEffect(() => {

    let typeValue = props.type || ''
    if (query?.[`Field-${index}`]?.type) {
      typeValue = query[`Field-${index}`].type
    }
    setType(typeValue)

    let fieldTypeValue = props.fieldType || ''
    if (query?.[`Field-${index}`]?.value) {
      fieldTypeValue = query[`Field-${index}`].value
    }
    setFieldType(fieldTypeValue)

  }, [query, index, props])

  var autoCompleteField
  const booleanField = (
    <Select
      {...props}
      labelKey='label'
      options={[
        {
          label: 'True',
          value: 'true'
        },
        {
          label: 'False',
          value: 'false'
        }
      ]}
      valueKey={{ key: 'value', reduce: true }}
    />)

  const dateField = (
    <DateInput
      format='dd/mm/yyyy'
      name={props.name}
    />)

  const integerField = (
    <TextInput
      name={props.name}
      type='number'
    />)

  const listField = (
    <Select
      {...props}
      labelKey='label'
      //   onChange={({ value: nextValue }) => {
      //     props.handleFieldChanged(props.name, nextValue)
      //   }}
      options={constants[list]}
      valueKey={{ key: 'value' }}
    />)

  const textField = (
    <TextInput
      name={props.name}
      type='text'
    />)

  const timeField = (
    <MaskedInput
      dropProps={{ background: { color: 'white' }, plain: true }}
      mask={[
        {
          length: [1, 2],
          options: Array.from({ length: 24 }, (v, k) => k + 1),
          regexp: /^[1-2][0-9]$|^[0-9]$/,
          placeholder: 'hh'
        },
        { fixed: ':' },
        {
          length: 2,
          options: ['00', '15', '30', '45'],
          regexp: /^[0-5][0-9]$|^[0-9]$/,
          placeholder: 'mm'
        }
      ]}
      name={props.name}
      // value={timeValue}
      // onChange={event => setTimeValue(event.target.value)}
    />)

  // Set Value field based on field datatype
  const setValue = async () => {
    switch (type) {
      case 'autocomplete':
        setValueField(autoCompleteField)
        break
      case 'boolean':
        setValueField(booleanField)
        break
      case 'date':
        setValueField(dateField)
        break
      case 'integer':
        setValueField(integerField)
        break
      case 'list':
        setValueField(listField)
        break
      case 'time':
        setValueField(timeField)
        break
      default:
        setValueField(textField)
    }
  }

  useEffect(() => {
    // let unmounted = false

    const getUsers = async (userType) => {
      const params = {
        fields: 'id,firstName,lastName,reference',
        limit: 2000,
        type: userType,
        showFormerStudents: 'false',
        where: {
          deleted: false
        }
      }

      const users = await UserService.getUsers(apiToken, params)

      const mappedUsers = users.data.map(item => (
        {
          label: item.firstName + ' ' + item.lastName,
          value: String(item.id)
        }
      ))
      setAutoCompleteValues(mappedUsers)
    }

    const getAcademicYears = async () => {
      const academicYears = await OrganisationTagService.getAcademicYears(apiToken, activeOrg)

      const mappedAcademicYears = academicYears.map(item => (
        {
          label: item,
          value: item
        }
      ))

      setAutoCompleteValues(mappedAcademicYears)
    }

    const getQuickBehaviours = async () => {
      const behaviours = await OrganisationTagService.getActiveQuickBehaviours(apiToken, activeOrg)

      const mappedBehaviours = behaviours.map(item => (
        {
          label: item,
          value: item
        }
      ))

      setAutoCompleteValues(mappedBehaviours)
    }

    const getDeescalationTechniques = async () => {
      const params = {
        fields: 'value',
        limit: 1,
        orgId: activeOrg.id
      }

      const where = {
        organisation: activeOrg.id,
        type: 'besmart',
        key: 'deescalationTechniques'
      }

      const techniques = await OrganisationTagService.get(apiToken, params, where)

      if (techniques) {
        const deescalationTechniques = JSON.parse(techniques[0].value)

        const mappedDeescalationTechniques = deescalationTechniques.map(item => (
          {
            label: item.technique,
            value: item.technique
          }
        ))

        setAutoCompleteValues(mappedDeescalationTechniques)
      }
    }

    const getPhysicalTechniques = async () => {
      const params = {
        fields: 'value',
        limit: 1,
        orgId: activeOrg.id
      }

      const where = {
        organisation: activeOrg.id,
        type: 'besmart',
        key: 'physicalTechniques'
      }

      const techniques = await OrganisationTagService.get(apiToken, params, where)

      if (techniques) {
        const physicalTechniques = JSON.parse(techniques[0].value)

        const mappedPhysicalTechniques = physicalTechniques.map(item => (
          {
            label: item.technique,
            value: item.technique
          }
        ))

        setAutoCompleteValues(mappedPhysicalTechniques)
      }
    }

    switch (fieldType) {
      case 'studentName':
        getUsers('student')
        break
      case 'studentsInvolved':
        getUsers('student')
        break
      case 'serviceuser_academicyear':
        getAcademicYears()
        break
      case 'staffName':
      case 'completedBy':
      case 'staffInvolved':
        getUsers('user')
        break
      case 'deescalationTechniques':
        getDeescalationTechniques()
        break
      case 'physicalTechnique':
        getPhysicalTechniques()
        break

      case 'injurySufferedByChild':
      case 'injurySufferedByStaff':
      case 'injurySufferedByOthers':
        setAutoCompleteValues([
          { label: 'True', value: 'true' }
        ])
        break

      case 'injurySufferedBy':
        let serviceUserTerm = terms.serviceUserTerm ? terms.serviceUserTerm : 'Student'
        setAutoCompleteValues([
          { label: 'Staff', value: 'staff' },
          { label: 'Others', value: 'other' },
          { label: serviceUserTerm, value: serviceUserTerm.toLowerCase() }
        ])
        break

      case 'positiveNegative':
        setAutoCompleteValues([
          { label: 'Positive', value: 'positive' },
          { label: 'Negative', value: 'negative' }
        ])
        break

      case 'quickBehaviour':
        getQuickBehaviours()
        break

      case 'medicalInterventionRequired':
        setAutoCompleteValues([
          { label: 'Yes', value: 'Yes' },
          { label: 'No', value: 'No' }
        ])
        break
    }

    setValue()

    // return () => { unmounted = true }
  }, [type, list, fieldType, query])

  useEffect(() => {
    var theseValues = autoCompleteValues
    // sort alphabetically

    theseValues.sort(function (a, b) {
      let labelA = String(a?.label || '')
      let labelB = String(b?.label || '')
      return labelA?.localeCompare(labelB)
    })

    autoCompleteField = (
      <Select
        {...props}
        labelKey='label'
        options={theseValues}
        valueKey={{ key: 'value', reduce: true }}
      />)

    setValue()
  }, [autoCompleteValues, query, type])
  return (
    <>
      {valueField}
    </>
  )
}

export default ValueBox
